import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { ScenarioInput } from '../../assets/images/UI-dashboard';

interface TextFieldInputProps {
  initialName: string;
  onSave: (name: string) => void;
}

const TextFieldInput: React.FC<TextFieldInputProps> = ({ initialName, onSave }) => {
  const [error, setError] = useState<string>('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSave(event.target.value.trim());
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!initialName.trim()) {
      setError('Scenario name cannot be empty.');
      return;
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
      }}
    >
      <img src={ScenarioInput} alt="Header Tag" />
      <TextField
        label="Scenario Name"
        value={initialName}
        onChange={handleChange}
        placeholder="Add scenario name"
        error={!!error}
        helperText={error}
        fullWidth
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        sx={{
          width: '400px',
          '& .MuiOutlinedInput-root': {
            height: '37px',
            borderRadius: '10px',
            borderBottom: '2px solid #E81C0E !important',
            '& fieldset': {
              borderColor: '#CCCCCC',
            },
            '&:hover fieldset': {
              borderColor: '#CCCCCC',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#CCCCCC',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(0, 0, 0, 0.4)',
            '&.Mui-focused': {
              color: '#CCCCCC',
            },
          },
          '& .MuiFormHelperText-root': {
            textAlign: 'left',
          },
        }}
      />
    </Box>
  );
};

export default TextFieldInput;
